import { CheckBoxOption, JobPostingStatus } from '@features/jobPostings';
import { amplitudeEventsName } from '@utils/amplitudeEvents';

export const jobPostingsKey = 'jobPostings';

export const jobPostingStatuses: JobPostingStatus[] = [
  {
    status: 1,
    label: 'Closed',
    color: 'error',
    event: amplitudeEventsName.JOBMANAGEMENT_CLICK_CLOSE_POSITION,
  },
  {
    status: 2,
    label: 'Accepting',
    color: 'yellow',
    event: amplitudeEventsName.JOBMANAGEMENT_CLICK_ACCEPTING_POSITION,
  },
  {
    status: 3,
    label: 'Hiring',
    color: 'success',
    event: amplitudeEventsName.JOBMANAGEMENT_CLICK_HIRING_POSITION,
  },
];

export const checkBoxOptions: CheckBoxOption[] = [
  { name: 'tips', label: 'Tips' },
  { name: 'commission', label: 'Commission' },
  { name: 'bonus', label: 'Bonus' },
  { name: 'incentives', label: 'Incentives' },
  { name: 'benefits', label: 'Benefits' },
];

export const updatedPositionTypes = [
  { value: 'Full Time', label: 'Full-Time' },
  { value: 'Part Time', label: 'Part-Time' },
  { value: 'Temporary', label: 'Temporary' },
  { value: 'Contractor', label: 'Contractor' },
  { value: 'Other', label: 'Other' },
];

export const payFrequencyTypes = [
  { value: 'Hourly', label: 'Hourly' },
  { value: 'Annually', label: 'Annually' },
  { value: 'Monthly', label: 'Monthly' },
  { value: 'Weekly', label: 'Weekly' },
  { value: 'Daily', label: 'Daily' },
];
